/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Why_Listening_Advantages_TitleInputs */

const en_why_listening_advantages_title = /** @type {(inputs: Why_Listening_Advantages_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What makes Listening hard not to love?`)
};

const es_why_listening_advantages_title = /** @type {(inputs: Why_Listening_Advantages_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Por qué es tan fácil enamorarse de Listening?`)
};

/**
* | output |
* | --- |
* | "What makes Listening hard not to love?" |
*
* @param {Why_Listening_Advantages_TitleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const why_listening_advantages_title = /** @type {((inputs?: Why_Listening_Advantages_TitleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Why_Listening_Advantages_TitleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_why_listening_advantages_title(inputs)
	return en_why_listening_advantages_title(inputs)
});